import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  showNavbar = false;

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit() {
    this.authenticationService.jsonWebTokenPayload$.subscribe(tokenLoad => {
      const requiresUserDetailByPath = [
          '/auth/home',
          '/auth/login',
          '/auth/sign-in',
          '/auth/reset-password'
      ].indexOf(window.location.pathname) === -1;
      if (
          requiresUserDetailByPath &&
        tokenLoad &&
        tokenLoad.username
      ) {
        this.authenticationService
          .getCurrentUser(tokenLoad.username)
          .toPromise()
          .then(
            user => {
              if (!user.passwordExpired) {
                this.showNavbar = true;
              }
            },
            error => {
              console.error(error);
            }
          );
      }
    });
  }
}
